/*
 * DEEP DIVES CONFIGURATION
 * This object contains the configuration information for all of our Deep Dive Tag Streams. These
 * are created as a way to build special stream packages for our deep dives, which
 * are normally just sent as a newsletter.
 *
 * TODO: Image handling should be changed so these image assets aren't included directly
 * in the site codebase. For some of the newer ones, I've started using uploader.axioscode.tools
 * to quickly upload the images without putting them directly in the code.
 *
 * TODO: This data should probably someday come from an API and there should be
 * a route on the site for axios.com/deep-dive/[slug] or something like that.
 */

export default [
  {
    name: "Refugee Crisis",
    slug: "deep-dive-refugee-crisis",
    title: "The refugee crisis is the worst it's been since WWII",
    image: require("assets/img/refugee-crisis.png"),
    ogImage: require("assets/img/refugee-crisis-social.jpg"),
  },
  {
    name: "Future of Retail",
    slug: "deep-dive-future-of-retail",
    title: "The battle to get shoppers out of the house",
    image: require("assets/img/retail-deep-dive.png"),
    ogImage: require("assets/img/retail-deep-dive-social.jpg"),
    issuesModuleConfig: [
      {
        name: "E-commerce",
        tagSlug: "e-commerce",
        backgroundColor: "#00abe9",
      },
      {
        name: "Shopping",
        tagSlug: "shopping",
        backgroundColor: "#d9318a",
      },
      {
        name: "Amazon",
        tagSlug: "amazon",
        backgroundColor: "#5ab279",
      },
      {
        name: "Walmart",
        tagSlug: "walmart",
        backgroundColor: "#5c4395",
      },
    ],
  },
  {
    name: "Davos",
    slug: "deep-dive-davos",
    title: "A new political and economic order is emerging",
    image: require("assets/img/davos-deep-dive.png"),
    ogImage: require("assets/img/davos-deep-dive-social.jpg"),
    issuesModuleConfig: [
      {
        name: "Economy",
        tagSlug: "economy",
        backgroundColor: "#d9de47",
      },
      {
        name: "Geopolitics",
        tagSlug: "global-politics",
        backgroundColor: "#9dbbf2",
      },
      {
        name: "Inequality",
        tagSlug: "economic-inequality",
        backgroundColor: "#e64f1d",
      },
      {
        name: "Globalization",
        tagSlug: "tradeglobalization",
        backgroundColor: "#414141",
      },
    ],
  },
  {
    name: "Business of Sports",
    slug: "deep-dive-business-of-sports",
    title: "The evolution of sports consumption and fandom",
    image: require("assets/img/business-of-sports-deep-dive.png"),
    ogImage: require("assets/img/business-of-sports-deep-dive-social.jpg"),
    issuesModuleConfig: [
      {
        name: "Esports",
        tagSlug: "esports",
        backgroundColor: "#a0dc29",
      },
      {
        name: "Sports Betting",
        tagSlug: "sports-betting",
        backgroundColor: "#ef5c66",
      },
      {
        name: "NFL",
        tagSlug: "national-football-league-nfl",
        backgroundColor: "#00d0e3",
      },
      {
        name: "Super Bowl",
        tagSlug: "super-bowl",
        backgroundColor: "#ff9300",
      },
    ],
  },
  {
    name: "Future of Dating",
    slug: "deep-dive-future-of-dating",
    title: "The gamification of courtship has gone global",
    image: require("assets/img/future-of-dating-deep-dive.png"),
    ogImage: require("assets/img/future-of-dating-deep-dive-social.jpg"),
    issuesModuleConfig: [
      {
        name: "Dating apps",
        tagSlug: "dating-apps",
        backgroundColor: "#905cff",
      },
      {
        name: "Online privacy",
        tagSlug: "online-privacy",
        backgroundColor: "#0091ff",
      },
      {
        name: "Facebook",
        tagSlug: "facebook",
        backgroundColor: "#ff69fa",
      },
      {
        name: "Tinder",
        tagSlug: "tinder",
        backgroundColor: "#ff5b47",
      },
    ],
  },
  {
    name: "Data Privacy",
    slug: "deep-dive-data-privacy",
    title:
      "Personal data is our most valuable asset, but we've given it away to powerful corporations",
    image: require("assets/img/data-privacy-deep-dive.png"),
    ogImage: require("assets/img/data-privacy-deep-dive-social.png"),
    issuesModuleConfig: [
      {
        name: "Online Privacy",
        tagSlug: "online-privacy",
        backgroundColor: "#656565",
      },
      {
        name: "Personal data",
        tagSlug: "personal-data",
        backgroundColor: "#656565",
      },
      {
        name: "Facebook",
        tagSlug: "facebook",
        backgroundColor: "#656565",
      },
      {
        name: "Google",
        tagSlug: "google",
        backgroundColor: "#656565",
      },
    ],
  },
  {
    name: "Millennial Jobs",
    slug: "deep-dive-millennial-jobs",
    title:
      "Millennials are facing one of the toughest economic landscapes since WWII",
    image: require("assets/img/millennial-jobs-deep-dive.png"),
    ogImage: require("assets/img/millennial-jobs-deep-dive-social.jpg"),
    issuesModuleConfig: [
      {
        name: "Automation",
        tagSlug: "automation",
        backgroundColor: "#b095ff",
      },
      {
        name: "Wages",
        tagSlug: "wages",
        backgroundColor: "#51abff",
      },
      {
        name: "Millennials",
        tagSlug: "millennials",
        backgroundColor: "#9cff75",
      },
      {
        name: "Jobs",
        tagSlug: "jobs",
        backgroundColor: "#ffa760",
      },
    ],
  },
  {
    name: "On-demand economy",
    slug: "deep-dive-on-demand-economy",
    title: "The on-demand economy is reshaping America's workforce",
    image:
      "https://graphics.axios.com/illustrations/2019-04-25-gig-economy-transparent.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2019-04-23-gig-economy-social.png",
    issuesModuleConfig: [
      {
        name: "Gig economy",
        tagSlug: "gig-economy",
        backgroundColor: "#e8bc19",
      },
      {
        name: "Future of work",
        tagSlug: "future-of-work",
        backgroundColor: "#6ba9c1",
      },
      {
        name: "Uber",
        tagSlug: "uber",
        backgroundColor: "#f43d14",
      },
      {
        name: "Automation",
        tagSlug: "automation",
        backgroundColor: "#589773",
      },
    ],
  },
  {
    name: "Neuroscience",
    slug: "deep-dive-neuroscience",
    title: "A special report on advances in understanding memory",
    image:
      "https://graphics.axios.com/illustrations/2019-05-18-neuroscience-header.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2019-05-18-neuroscience-social.jpg",
    issuesModuleConfig: [
      {
        name: "Neuroscience",
        tagSlug: "neuroscience",
        backgroundColor: "#4e9863",
      },
      {
        name: "Alzheimer's disease",
        tagSlug: "alzheimers-disease",
        backgroundColor: "#74c688",
      },
      {
        name: "Artificial intelligence",
        tagSlug: "artificial-intelligence",
        backgroundColor: "#8ed98c",
      },
      {
        name: "Deepfakes",
        tagSlug: "deepfakes",
        backgroundColor: "#9cf0a2",
      },
    ],
  },
  {
    name: "Global Threats",
    slug: "deep-dive-global-threats",
    title: "A special report on the greatest threats we face.",
    image:
      "https://graphics.axios.com/illustrations/2019-06-01-threats-transparent.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2019-06-01-threats-social.png",
    issuesModuleConfig: [
      {
        name: "Russia",
        tagSlug: "russia",
        backgroundColor: "#b82b1d",
      },
      {
        name: "China",
        tagSlug: "china",
        backgroundColor: "#000000",
      },
      {
        name: "Climate Change",
        tagSlug: "climate-change",
        backgroundColor: "#6c6c6c",
      },
      {
        name: "Cybersecurity",
        tagSlug: "cybersecurity",
        backgroundColor: "#dedede",
      },
    ],
  },
  {
    name: "Criminal Justice",
    slug: "deep-dive-criminal-justice",
    title: "A special report on the industry around U.S. incarceration",
    image:
      "https://graphics.axios.com/illustrations/2019-06-08-criminal-justice-header.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2019-06-08-criminal-justice-social.jpg",
    issuesModuleConfig: [
      {
        name: "Prisons",
        tagSlug: "prisons",
        backgroundColor: "#ea3528",
      },
      {
        name: "Prison Reform",
        tagSlug: "prison-reform",
        backgroundColor: "#99a1ab",
      },
      {
        name: "Criminal Justice",
        tagSlug: "criminal-justice",
        backgroundColor: "#24a427",
      },
      {
        name: "Poverty",
        tagSlug: "poverty",
        backgroundColor: "#232323",
      },
    ],
  },
  {
    name: "Plastics",
    slug: "deep-dive-plastics",
    title: "A special report on the global plastics problem",
    image:
      "https://graphics.axios.com/illustrations/2019-06-15-plastics-header.png",
    ogImage:
      "https://graphics.axios.com/illustrations/2019-06-15-plastics-social.jpg",
    issuesModuleConfig: [
      {
        name: "Pollution",
        tagSlug: "pollution",
        backgroundColor: "#0dba86",
      },
      {
        name: "Climate Change",
        tagSlug: "climate-change",
        backgroundColor: "#24f0b2",
      },
      {
        name: "Plastic",
        tagSlug: "plastic",
        backgroundColor: "#0d98ba",
      },
      {
        name: "Environment",
        tagSlug: "environment",
        backgroundColor: "#0d42ba",
      },
    ],
  },
];
